import TemplateHandler from './template-handle'

export default TemplateHandler
